module.exports = __webpack_public_path__ + "static/weed-control.bcdddea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weed-control.jpg
// module id = 129
// module chunks = 191454632424336 249675431891645